import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Subject, throwError } from 'rxjs';
import { catchError, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CurrentUserService } from '@services/current-user/current-user.service';
import { SessionTimeoutService } from '@services/session-timeout/session-timeout.service';
import { isCEAdminUser } from '@module-role/utils';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Tungsten';
  private _destroy$ = new Subject();
  showLoader = false;

  constructor(
    private _currUser: CurrentUserService,
    private _auth: AuthService,
    private _sessionTimeout: SessionTimeoutService,
    private _router: Router,
    private _renderer: Renderer2
  ) {}

  ngOnDestroy(): void {
    this._destroy$.next(null);
  }

  ngOnInit(): void {
    this._auth.isAuthenticated$
      .pipe(
        filter((x) => !!x),
        tap(() => this._sessionTimeout.init()),
        switchMap(() => this._currUser.queryCurrentUser()),
        catchError((e) => {
          this.showLoader = false;
          return throwError(e);
        }),
        tap((user) => {
          this.showLoader = false;
          if (isCEAdminUser(user) && !user.coveredentities[0]?.onboarded) {
            this._router.navigate([
              `/ce/onboarding/${user.coveredentities[0]?.id}`
            ]);
          }
        }),
        takeUntil(this._destroy$)
      )
      .subscribe();

    if (environment.enableDemoFeatures) {
      const extChartsScript = this._renderer.createElement('script');
      extChartsScript.src = 'assets/scripts/charts-4.0.0.js';
      this._renderer.appendChild(document.body, extChartsScript);
    }
  }
}
